import { PrimitiveAtom, useSetAtom } from 'jotai';
import { Alert, AlertColor } from '@mui/material';
import { SnackbarMessage } from '@/types';
import { snackbarMessage as TemplateBuilderSnackbarMessage } from './state';

type Props = {
  atom?: PrimitiveAtom<SnackbarMessage>;
  variant?: 'filled' | 'standard' | 'outlined';
};

export const useSnackBarMessage = ({
  atom = TemplateBuilderSnackbarMessage,
  variant = 'filled',
}: Props) => {
  const setSnackbarMessage = useSetAtom(atom);
  const showSnackBar = (message: string, severity: AlertColor) => {
    setSnackbarMessage({
      shouldShow: true,
      content: (
        <Alert sx={{ color: 'white' }} variant={variant} severity={severity}>
          {message && (
            <>
              {message}
              &nbsp;&nbsp;
            </>
          )}
        </Alert>
      ),
    });
  };

  return {
    showSnackBar,
  };
};
